import * as React from 'react'
import { ReactElement } from 'react'
import { ListItemDto } from '../../config/partyConfig'
import EntityDropdown, { EntityComboboxProps } from './EntityCombobox'

type Props = Partial<EntityComboboxProps<ListItemDto>> &
    Required<Pick<EntityComboboxProps<ListItemDto>, 'selectedOptions' | 'onOptionSelect' | 'dataPromise'>>
export default function LegalAidBoardCombobox(props: Props): ReactElement {
    return (
        <EntityDropdown<ListItemDto>
            getEntityLabel={party => party.displayName}
            getEntityValue={party => party.id}
            placeholderKey={'base.legalaidboardcombobox.placeholder'}
            {...props}
        />
    )
}
